import React from 'react';
import { Box, IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { styled } from '@mui/material/styles';

const SlidingModalContainer = styled(Box)(({ theme, isfullwidth }) => ({
  position: 'fixed',
  top: '60px', // Below header
  right: 0,
  height: 'calc(100% - 140px)',
  width: isfullwidth ? '100%' : '50%',
  backgroundColor: 'rgba(255, 255, 255, 0.98)',
  boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',
  zIndex: 1200,
  transition: 'width 0.3s ease-in-out',
  display: 'flex',
  flexDirection: 'column',
  borderLeft: '1px solid #e0e0e0',
  '@media (max-width: 900px)': {
    width: isfullwidth ? '100%' : '50%',
    height: 'calc(100% - 190px)',
  },
  '@media (max-width: 758px)': {
    width: isfullwidth ? '100%' : '85%',
    
  },
  '@media (max-width:600px)': {
    width: isfullwidth ? '100%' : '85%',
    height: 'calc(100% - 350px)',
  },
}));

const SlidingModal = ({
  isOpen,
  children,
  isFullWidth,
  onToggleWidth
}) => {
  if (!isOpen) return null;

  return (
    <SlidingModalContainer isfullwidth={isFullWidth ? 1 : 0}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#239b69',
        color: 'white',
      }}>
        <IconButton
          onClick={onToggleWidth}
          size="small"
          sx={{ color: 'white' }}
          title={isFullWidth ? 'Reducir ancho' : 'Ampliar ancho'}
        >
          {isFullWidth ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
      </Box>
      <Box sx={{ 
        flex: 1, 
        overflowY: 'auto',
      }}>
        {children}
      </Box>
    </SlidingModalContainer>
  );
};

export default SlidingModal;
